// src/components/Topbar.jsx
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  Popover,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { useTranslation } from 'react-i18next';
import { useLanguage } from 'src/context/languageContext';
import { languages } from 'src/constants/languages';
import { tokens } from 'src/theme';
import { RoleContext } from 'src/context/roleContext';
import { getSchoolInfo } from 'src/api/schoolMetod';
import { SKOLA } from 'src/constants/role';
import { ActiveModesContext } from 'src/context/ActiveModesContext';
import { modeDescriptions } from 'src/constants/competitions';
import { useNavigate } from 'react-router-dom';
import ReactCountryFlag from 'react-country-flag';

/* TOP BAR KOJI SE PRIKAZUJE NA APLIKACJI */
const Topbar = ({ onLogout }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();
  const { role, userId, setRole, setUserId } = useContext(RoleContext);
  const { activeModes } = useContext(ActiveModesContext);
  const navigate = useNavigate();

  const [schoolinfo, setSchoolinfo] = useState(null);
  const activeModeKey = activeModes.find((mode) => modeDescriptions[mode]);
  const activeMode = activeModeKey
    ? t(`modes.${activeModeKey}`, { defaultValue: activeModeKey })
    : t('noActiveMode');

  const [anchorEl, setAnchorEl] = useState(null);

  const handleLanguageClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (lng) => {
    changeLanguage(lng);
    handleLanguageClose();
  };

  useEffect(() => {
    if (role === SKOLA && userId) {
      const idMatch = userId.match(/\d+/);
      if (idMatch) {
        setUserId(idMatch[0]);
        getSchoolInfo(idMatch[0])
          .then((data) => setSchoolinfo(data))
          .catch((error) =>
            console.error(
              'Greška prilikom preuzimanja informacija o školi:',
              error
            )
          );
      }
    }
  }, [role, userId]);

  const currentLanguage = languages.find((lang) => lang.code === language);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      sx={{
        background: '#2596be',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px'
      }}
    >
      {/* Leva sekcija sa informacijama o školi */}
      <Box>
        <Typography variant="h4" fontWeight="600" color="#ffffff">
          {t('text.welcome', {
            name: schoolinfo ? schoolinfo['name'] : ''
          })}
        </Typography>
      </Box>
      {role === SKOLA && userId && (
        <>
          {/* Srednja sekcija sa aktivnim modom */}
          <Box textAlign="center" flex={1}>
            <Typography variant="h6" color="#ffffff">
              {t('activeMode')}
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="#ffcc00">
              {activeMode}
            </Typography>
          </Box>
        </>
      )}

      {/* Desna sekcija sa ikonama */}
      <Box display="flex" alignItems="center">
        {/* Ikona i naziv trenutnog jezika */}
        <Box display="flex" alignItems="center" mr={2}>
          {currentLanguage && (
            <>
              <ReactCountryFlag
                countryCode={currentLanguage.countryCode}
                svg
                style={{
                  width: '24px',
                  height: '24px',
                  marginRight: '8px'
                }}
                title={t(currentLanguage.name)}
              />
              <Typography variant="body1" color="#ffffff">
                {t(currentLanguage.name)}
              </Typography>
            </>
          )}
        </Box>

        {/* Ikona za izbor jezika */}
        <IconButton onClick={handleLanguageClick} aria-label="Izaberi jezik">
          <LanguageOutlinedIcon sx={{ color: '#ffffff' }} />
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleLanguageClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <List>
            {languages.map((lang) => (
              <ListItem key={lang.code} disablePadding>
                <ListItemButton onClick={() => handleLanguageSelect(lang.code)}>
                  <ListItemText primary={t(lang.name)} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Popover>

        {/* Ikona za profil */}
        <IconButton
          onClick={() => navigate('/ProfilePage')}
          aria-label="Profil"
        >
          <PersonOutlinedIcon sx={{ color: '#ffffff' }} />
        </IconButton>

        {/* Ikona za odjavu */}
        <IconButton onClick={onLogout} aria-label="Odjavi se">
          <LogoutOutlinedIcon sx={{ color: '#ffffff' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;
